export function isLoading(isLoading, isFetching) {
  try {
    if (isLoading || isFetching) {
      return true;
    }
    return false;
  } catch (error) {
    console.log(error);
  }
}

export function validateExerciseForm(formValues, formImages, isEdit) {
  let errors = {};

  if (!formValues.exerciseName) {
    errors.exerciseName = "required";
  }

  if (!formValues.selMovementType) {
    errors.selMovementType = "required";
  }

  if (!formValues.selPrimaryMuscle) {
    errors.selPrimaryMuscle = "required";
  }

  if (
    formValues.selMovementType?.value === "compound" &&
    formValues.selSecondaryMuscle?.length === 0
  ) {
    errors.selSecondaryMuscle = "required";
  }

  if (!formValues.selWorkoutMode) {
    errors.selWorkoutMode = "required";
  }

  if (!formValues.tentiveCalorie) {
    errors.tentiveCalorie = "required";
  }

  if (formValues.selAltrnateWorkouts?.length === 0) {
    errors.selAltrnateWorkouts = "required";
  }

  if (
    formValues.selWorkoutMode?.value !== "rep_based" &&
    !formValues.selTentativeDurationHH &&
    !formValues.selTentativeDurationMM &&
    !formValues.selTentativeDurationSS
  ) {
    errors.selTentativeDurationSS = "required";
  }

  if (
    formValues.selWorkoutMode?.value === "rep_based" &&
    !formValues.tentativeReps
  ) {
    errors.tentativeReps = "required";
  }

  if (!formValues.describeExercise) {
    errors.describeExercise = "required";
  }

  // if (
  //   !isEdit &&
  //   formValues.selFileType?.value !== "link" &&
  //   formImages.exerciseIconImg.length === 0
  // ) {
  //   errors.exerciseIconImg = "Thumbnail is required!";
  // }

  // if (
  //   !isEdit &&
  //   formValues.selFileType?.value !== "link" &&
  //   formImages.exerciseVideo.length === 0
  // ) {
  //   errors.exerciseVideo = "Cover Image is required!";
  // }

  return errors;
}

export function validateEquipmentForm(formValues) {
  let errors = {};

  if (!formValues.equipmentName) {
    errors.equipmentName = "required";
  }

  return errors;
}

export function validateWorkoutPackageForm(formValues, exerciseDays) {
  let errors = {};

  if (!formValues.planName) {
    errors.planName = "required";
  }

  if (!formValues.planDuration) {
    errors.planDuration = "required";
  }

  if (!formValues.selPlanSuitableFor) {
    errors.selPlanSuitableFor = "required";
  }

  if (!formValues.selPlanType) {
    errors.selPlanType = "required";
  }

  if (!formValues.selPlanAccess) {
    errors.selPlanAccess = "required";
  }

  if (!formValues.description) {
    errors.description = "required";
  }

  return errors;
}

export function validateWorkoutPackageFormDays12(exerciseDays) {
  let errors = {};

  exerciseDays.forEach((day, dayIndex) => {
    let dayErrors = {};

    if (!day.selSetType) {
      dayErrors.selSetType = "required";
    }

    day.allExercises.forEach((exercise, exerciseIndex) => {
      let exerciseErrors = {};

      if (!exercise.selCategoryName || !exercise.selCategoryName.value) {
        exerciseErrors.selCategoryName = "required";
      }

      if (!exercise.selExerciseName || !exercise.selExerciseName.value) {
        exerciseErrors.selExerciseName = "required";
      }

      if (!exercise.restTime) {
        exerciseErrors.restTime = "required";
      }

      exercise.allSets.forEach((set, setIndex) => {
        let setErrors = {};

        if (
          exercise.selCategoryName?.label?.toLowerCase() !== "cardio" &&
          !set.weight
        ) {
          setErrors.weight = "required";
        }

        if (
          exercise.selCategoryName?.label?.toLowerCase() === "cardio" &&
          !set.selTentativeDurationHH &&
          !set.selTentativeDurationMM &&
          !set.selTentativeDurationSS
        ) {
          setErrors.selTentativeDurationSS = "required";
        }

        if (
          exercise.selCategoryName?.label?.toLowerCase() !== "cardio" &&
          !set.reps
        ) {
          setErrors.reps = "required";
        }

        if (Object.keys(setErrors).length > 0) {
          if (!exerciseErrors.allSets) {
            exerciseErrors.allSets = [];
          }
          exerciseErrors.allSets[setIndex] = setErrors;
        }
      });

      if (Object.keys(exerciseErrors).length > 0) {
        if (!dayErrors.allExercises) {
          dayErrors.allExercises = [];
        }
        dayErrors.allExercises[exerciseIndex] = exerciseErrors;
      }
    });

    if (Object.keys(dayErrors).length > 0) {
      if (!errors.exerciseDays) {
        errors.exerciseDays = [];
      }
      errors.exerciseDays[dayIndex] = dayErrors;
    }
  });

  return Object.keys(errors).length > 0 ? errors : null;
}

export function validateWorkoutPackageFormDays2(exerciseDays) {
  let errors = {};

  exerciseDays.forEach((day, dayIndex) => {
    let dayErrors = {};

    if (!day.allSetTypes || day.allSetTypes.length === 0) {
      dayErrors.allSetTypes = "At least one set type is required";
    } else {
      day.allSetTypes.forEach((setType, setTypeIndex) => {
        let setTypeErrors = {};

        if (!setType.selSetType) {
          setTypeErrors.selSetType = "Set type is required";
        }

        let sequenceNumbers = new Set();

        setType.allExercises.forEach((exercise, exerciseIndex) => {
          let exerciseErrors = {};

          if (!exercise.selCategoryName || !exercise.selCategoryName.value) {
            exerciseErrors.selCategoryName = "Category name is required";
          }

          if (!exercise.selExerciseName || !exercise.selExerciseName.value) {
            exerciseErrors.selExerciseName = "Exercise name is required";
          }

          if (!exercise.restTime) {
            exerciseErrors.restTime = "Rest time is required";
          }

          if (!exercise.sequenceNo) {
            exerciseErrors.sequenceNo = "Sequence number is required";
          } else if (sequenceNumbers.has(exercise?.sequenceNo)) {
            exerciseErrors.sequenceNo =
              "Sequence number must be unique within a set type";
          } else {
            sequenceNumbers.add(exercise?.sequenceNo);
          }

          exercise.allSets.forEach((set, setIndex) => {
            let setErrors = {};

            if (
              exercise.selCategoryName?.label?.toLowerCase() !== "cardio" &&
              !set.weight
            ) {
              setErrors.weight = "Weight is required";
            }

            if (
              exercise.selCategoryName?.label?.toLowerCase() === "cardio" &&
              !set.selTentativeDurationHH &&
              !set.selTentativeDurationMM &&
              !set.selTentativeDurationSS
            ) {
              setErrors.selTentativeDurationSS =
                "Tentative duration is required";
            }

            if (
              exercise.selCategoryName?.label?.toLowerCase() !== "cardio" &&
              !set.reps
            ) {
              setErrors.reps = "Reps are required";
            }

            if (Object.keys(setErrors).length > 0) {
              if (!exerciseErrors.allSets) {
                exerciseErrors.allSets = [];
              }
              exerciseErrors.allSets[setIndex] = setErrors;
            }
          });

          if (Object.keys(exerciseErrors).length > 0) {
            if (!setTypeErrors.allExercises) {
              setTypeErrors.allExercises = [];
            }
            setTypeErrors.allExercises[exerciseIndex] = exerciseErrors;
          }
        });

        if (Object.keys(setTypeErrors).length > 0) {
          if (!dayErrors.allSetTypes) {
            dayErrors.allSetTypes = [];
          }
          dayErrors.allSetTypes[setTypeIndex] = setTypeErrors;
        }
      });
    }

    if (Object.keys(dayErrors).length > 0) {
      if (!errors.exerciseDays) {
        errors.exerciseDays = [];
      }
      errors.exerciseDays[dayIndex] = dayErrors;
    }
  });

  return Object.keys(errors).length > 0 ? errors : null;
}

export function validateWorkoutPackageFormDays(exerciseDays) {
  let errors = {};

  exerciseDays.forEach((day, dayIndex) => {
    let dayErrors = {};

    if (!day.allSetTypes || day.allSetTypes.length === 0) {
      dayErrors.allSetTypes = "At least one set type is required";
    } else {
      day.allSetTypes.forEach((setType, setTypeIndex) => {
        let setTypeErrors = {};

        if (!setType.selSetType) {
          setTypeErrors.selSetType = "Set type is required";
        }

        let sequenceNumbers = new Set();

        setType.allExercises.forEach((exercise, exerciseIndex) => {
          let exerciseErrors = {};

          if (!exercise.selCategoryName || !exercise.selCategoryName.value) {
            exerciseErrors.selCategoryName = "Category name is required";
          }

          if (!exercise.selExerciseName || !exercise.selExerciseName.value) {
            exerciseErrors.selExerciseName = "Exercise name is required";
          }

          if (!exercise.restTime) {
            exerciseErrors.restTime = "Rest time is required";
          }

          if (!exercise.sequenceNo) {
            exerciseErrors.sequenceNo = "Sequence number is required";
          } else if (sequenceNumbers.has(exercise?.sequenceNo)) {
            exerciseErrors.sequenceNo =
              "Sequence number must be unique within a set type";
          } else {
            sequenceNumbers.add(exercise?.sequenceNo);
          }

          exercise.allSets.forEach((set, setIndex) => {
            let setErrors = {};

            // Check if the exercise is time-based or not
            if (exercise.selExerciseName?.info?.workout_mode === "time_based") {
              // Time-based exercise, validate the duration fields
              if (
                !set.selTentativeDurationHH &&
                !set.selTentativeDurationMM &&
                !set.selTentativeDurationSS
              ) {
                setErrors.selTentativeDurationSS =
                  "Tentative duration is required";
              }
            } else {
              // Rep-based exercise, validate weight and reps
              if (!set.weight) {
                setErrors.weight = "Weight is required";
              }

              if (!set.reps) {
                setErrors.reps = "Reps are required";
              }
            }

            // Add any errors for the set
            if (Object.keys(setErrors).length > 0) {
              if (!exerciseErrors.allSets) {
                exerciseErrors.allSets = [];
              }
              exerciseErrors.allSets[setIndex] = setErrors;
            }
          });

          // Add any errors for the exercise
          if (Object.keys(exerciseErrors).length > 0) {
            if (!setTypeErrors.allExercises) {
              setTypeErrors.allExercises = [];
            }
            setTypeErrors.allExercises[exerciseIndex] = exerciseErrors;
          }
        });

        // Add any errors for the set type
        if (Object.keys(setTypeErrors).length > 0) {
          if (!dayErrors.allSetTypes) {
            dayErrors.allSetTypes = [];
          }
          dayErrors.allSetTypes[setTypeIndex] = setTypeErrors;
        }
      });
    }

    // Add any errors for the day
    if (Object.keys(dayErrors).length > 0) {
      if (!errors.exerciseDays) {
        errors.exerciseDays = [];
      }
      errors.exerciseDays[dayIndex] = dayErrors;
    }
  });

  // Return the errors object, or null if there are no errors
  return Object.keys(errors).length > 0 ? errors : null;
}

export function validateWorkoutPackageFormDays1(exerciseDays) {
  let errors = {};

  // Validate each day
  exerciseDays.forEach((day, dayIndex) => {
    let dayErrors = {};

    if (!day.selSetType) {
      day.selSetType = "required";
    }

    // Validate each exercise in the day
    day.allExercises.forEach((exercise, exerciseIndex) => {
      let exerciseErrors = {};

      // Check required fields in each exercise
      if (!exercise.selCategoryName || !exercise.selCategoryName.value) {
        exerciseErrors.selCategoryName = "required";
      }

      if (!exercise.selExerciseName || !exercise.selExerciseName.value) {
        exerciseErrors.selExerciseName = "required";
      }

      if (!exercise.restTime) {
        exerciseErrors.restTime = "required";
      }

      // Validate each set in the exercise
      exercise.allSets.forEach((set, setIndex) => {
        let setErrors = {};

        if (!set.weight) {
          setErrors.weight = "required";
        }
        if (!set.reps) {
          setErrors.reps = "required";
        }

        // If there are set errors, add them to the exercise errors
        if (Object.keys(setErrors).length > 0) {
          if (!exerciseErrors.allSets) {
            exerciseErrors.allSets = [];
          }
          exerciseErrors.allSets[setIndex] = setErrors;
        }
      });

      // If there are exercise errors, add them to the day errors
      if (Object.keys(exerciseErrors).length > 0) {
        if (!dayErrors.allExercises) {
          dayErrors.allExercises = [];
        }
        dayErrors.allExercises[exerciseIndex] = exerciseErrors;
      }
    });

    // If there are day errors, add them to the overall errors
    if (Object.keys(dayErrors).length > 0) {
      if (!errors.exerciseDays) {
        errors.exerciseDays = [];
      }
      errors.exerciseDays[dayIndex] = dayErrors;
    }
  });

  // Return errors if any, otherwise return null
  return Object.keys(errors).length > 0 ? errors : {};
}

export function validateWorkoutCategoryForm(formValues, formImages, isEdit) {
  let errors = {};

  if (!formValues.catName) {
    errors.catName = "required";
  }

  // if (!formValues.description) {
  //   errors.description = "required";
  // }

  if (!isEdit && formImages.image.length === 0) {
    errors.image = "required!";
  }

  return errors;
}
